// import Performance from 'sinosafe-web-report/dist/performance.js';
import FastClick from 'fastclick';
import Vue from 'vue';
import Vuerify from 'vuerify';
import VueMeta from 'vue-meta'

import {
  sync,
} from 'vuex-router-sync';
import ToastPlugin from 'vux/src/plugins/toast/index.js';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js';
import LoadingPlugin from 'vux/src/plugins/loading/index.js';
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import {transform, showDataOnly, disabled} from './directive/index';
import { filterLicenseNo2 } from "./filters/index";
import { RadioGroup, Radio ,PullRefresh } from 'vant';

Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(PullRefresh);
import { isEnableOpenWeapp } from './utils'
import wechat from '@/common/wechat'

if (isEnableOpenWeapp()) {
  // 初始化
  wechat.init()
}
Vue.use(VueMeta);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);
Vue.use(Vuerify);
Vue.use(LoadingPlugin);
Vue.use(DatetimePlugin);
Vue.use(AlertPlugin);

import App from './App.vue'
import router from './router'
import store from './store'


// http请求
import {http, get} from './http';

window.$http = window.$post = Vue.prototype.$http = http;
window.$get = Vue.prototype.$get = get;


window.Toast = function(text){
  Vue.$vux.toast.show({
    text: text,
    type: 'text',
    'isShowMask': true,
    width: '16em',
  });
};

window.Loading = {
  show(text){
    text = text || 'Loading';
    Vue.$vux.loading.show({text});
  },
  hide(){
    Vue.$vux.loading.hide();
  }
}



Vue.config.productionTip = false
// Vue.config.errorHandler = function (err, vm, info) {
//   Performance.report(err);
// };

sync(store, router);
Vue.router = router; // 便于访问


function refreshRem(){
  let docEl = document.documentElement;
  let rem =100 * docEl.clientWidth / 750;

  docEl.style.fontSize = rem + 'px';
}
refreshRem();
window.addEventListener('resize', function(){
  refreshRem();
}, false);


if (/Android/gi.test(navigator.userAgent)) {
  window.addEventListener('resize', () => {
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      window.setTimeout(() => {
        // document.activeElement.scrollIntoViewIfNeeded();
        document.activeElement.scrollIntoView();
      }, 0);
    }
  });
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
